import React, { useState, useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';
import { AxiosInstance } from '../baseUrl';
import Swal from 'sweetalert2';
import { format } from 'date-fns';

const COLORS = [
    { value: 'green',  label: 'Зелений',    sub: '100 грн / заняття', dot: '#33B679', textColor: '#fff' },
    { value: 'blue',   label: 'Синій',      sub: '230 грн / заняття', dot: '#4a90d9', textColor: '#fff' },
    { value: 'purple', label: 'Фіолетовий', sub: 'Своя ціна',         dot: '#9b59b6', textColor: '#fff' },
];

const toInput = (date) => date ? format(new Date(date), "yyyy-MM-dd'T'HH:mm") : '';

export default function CreateEventModal({ show, onHide, initialSlot, onCreated }) {
    const [title,         setTitle]         = useState('');
    const [titleMode,     setTitleMode]     = useState('select');
    const [colorType,     setColorType]     = useState('green');
    const [start,         setStart]         = useState('');
    const [recur,         setRecur]         = useState('');
    const [seriesId,      setSeriesId]      = useState('');
    const [seriesMode,    setSeriesMode]    = useState('select');
    const [students,      setStudents]      = useState([]);
    const [allTitles,     setAllTitles]     = useState([]);
    const [allStudents,   setAllStudents]   = useState([]);
    const [seriesOptions, setSeriesOptions] = useState([]);
    const [studentCount,  setStudentCount]  = useState(1);
    const [loading,       setLoading]       = useState(false);

    useEffect(() => {
        if (initialSlot) { setStart(toInput(initialSlot.start)); }
    }, [initialSlot]);

    useEffect(() => {
        AxiosInstance.get('/events/titles').then(r => setAllTitles(r.data)).catch(() => {});
        AxiosInstance.get('/events/series').then(r => setSeriesOptions(r.data)).catch(() => {});
        AxiosInstance.get('/students').then(r => setAllStudents(r.data)).catch(() => {});
    }, []);

    const reset = () => {
        setTitle(''); setTitleMode('select'); setColorType('green'); setStart('');
        setRecur(''); setSeriesId(''); setSeriesMode('select');
        setStudents([]); setStudentCount(1);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!title.trim() || !start) return;
        setLoading(true);
        try {
            await AxiosInstance.post('/events', {
                title,
                color_type:      colorType,
                start_time:      start + ':00',
                end_time:        null,
                recurrence_rule: recur || null,
                student_count:   colorType === 'purple' ? studentCount : 1,
                student_ids:     colorType === 'purple' ? students : [],
                series_id:       seriesId ? parseInt(seriesId, 10) : null,
            });
            onCreated();
            onHide();
            reset();
        } catch {
            Swal.fire({ icon: 'error', title: 'Помилка', text: 'Не вдалося створити подію', background: '#1a1a1a', color: '#e8e8e8' });
        } finally {
            setLoading(false);
        }
    };

    const toggleStudent = (id) =>
        setStudents(prev => prev.includes(id) ? prev.filter(s => s !== id) : [...prev, id]);

    const selected = COLORS.find(c => c.value === colorType);

    return (
        <Modal show={show} onHide={onHide} centered size="md">
            <div style={{ background: '#161616', borderRadius: 12, border: '1px solid #2e2e2e', overflow: 'hidden' }}>

                {/* Header */}
                <div style={{ padding: '20px 24px 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div>
                        <h5 style={{ color: '#e8e8e8', margin: 0, fontWeight: 700 }}>Нова подія</h5>
                        <p style={{ color: '#555', fontSize: 12, margin: '2px 0 0' }}>Заняття з учнем</p>
                    </div>
                    <button onClick={onHide} style={{ background: 'none', border: 'none', color: '#555', fontSize: 20, cursor: 'pointer', lineHeight: 1 }}>×</button>
                </div>

                <Form onSubmit={handleSubmit} style={{ padding: '20px 24px 24px' }}>

                    {/* Title — select from students or type custom */}
                    <Form.Group className="mb-4">
                        <select
                            value={titleMode === 'custom' ? '__custom__' : title}
                            onChange={e => {
                                if (e.target.value === '__custom__') {
                                    setTitleMode('custom'); setTitle('');
                                } else {
                                    setTitleMode('select'); setTitle(e.target.value);
                                }
                            }}
                            style={{
                                background: '#0f0f0f', border: '1px solid #2e2e2e',
                                color: (title || titleMode === 'custom') ? '#e8e8e8' : '#555',
                                borderRadius: 8, padding: '12px 14px', fontSize: 15, fontWeight: 500,
                                width: '100%',
                            }}
                        >
                            <option value="">— оберіть учня —</option>
                            {allTitles.map(t => <option key={t} value={t}>{t}</option>)}
                            <option value="__custom__">Інша назва...</option>
                        </select>
                        {titleMode === 'custom' && (
                            <Form.Control
                                value={title} onChange={e => setTitle(e.target.value)}
                                placeholder="Введіть назву" required
                                style={{
                                    background: '#0f0f0f', border: '1px solid #2e2e2e', color: '#e8e8e8',
                                    borderRadius: 8, padding: '12px 14px', fontSize: 15, fontWeight: 500,
                                    marginTop: 6,
                                }}
                            />
                        )}
                    </Form.Group>

                    {/* Color picker */}
                    <Form.Group className="mb-4">
                        <Form.Label style={lbl}>Тип заняття</Form.Label>
                        <div style={{ display: 'flex', gap: 8 }}>
                            {COLORS.map(c => (
                                <button
                                    key={c.value} type="button"
                                    onClick={() => setColorType(c.value)}
                                    style={{
                                        flex: 1, padding: '10px 6px', borderRadius: 10, cursor: 'pointer',
                                        background: colorType === c.value ? `${c.dot}22` : '#0f0f0f',
                                        border: colorType === c.value ? `2px solid ${c.dot}` : '2px solid #2e2e2e',
                                        transition: 'all 0.15s',
                                    }}
                                >
                                    <div style={{ width: 14, height: 14, borderRadius: '50%', background: c.dot, margin: '0 auto 6px' }} />
                                    <div style={{ color: colorType === c.value ? c.dot : '#888', fontSize: 12, fontWeight: 600 }}>{c.label}</div>
                                    <div style={{ color: '#555', fontSize: 10, marginTop: 2 }}>{c.sub}</div>
                                </button>
                            ))}
                        </div>
                    </Form.Group>

                    {/* Start time only */}
                    <Form.Group className="mb-4">
                        <Form.Label style={lbl}>Початок *</Form.Label>
                        <Form.Control type="datetime-local" value={start} onChange={e => setStart(e.target.value)} required style={inp} />
                        <div style={{ color: '#444', fontSize: 11, marginTop: 3 }}>тривалість 1 год за замовчуванням</div>
                    </Form.Group>

                    {/* Repeat */}
                    <Form.Group className="mb-4">
                        <Form.Label style={lbl}>Повторення</Form.Label>
                        <div style={{ display: 'flex', gap: 6 }}>
                            {[['', 'Разово'], ['weekly', 'Щотижня']].map(([v, l]) => (
                                <button key={v} type="button" onClick={() => setRecur(v)} style={{
                                    padding: '7px 16px', borderRadius: 8, border: recur === v ? '2px solid #5865f2' : '2px solid #2e2e2e',
                                    background: recur === v ? '#5865f222' : '#0f0f0f', color: recur === v ? '#5865f2' : '#888',
                                    fontSize: 12, fontWeight: 600, cursor: 'pointer', transition: 'all 0.15s',
                                }}>
                                    {l}
                                </button>
                            ))}
                        </div>
                        {recur === 'weekly' && (
                            <div style={{ color: '#555', fontSize: 11, marginTop: 6 }}>
                                Буде створено 26 занять (~6 місяців)
                            </div>
                        )}
                    </Form.Group>

                    {/* Purple: students */}
                    {colorType === 'purple' && (
                        <>
                            <Form.Group className="mb-3">
                                <Form.Label style={lbl}>Кількість учнів у групі</Form.Label>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <button type="button" onClick={() => setStudentCount(v => Math.max(1, v - 1))} style={counterBtn}>−</button>
                                    <span style={{ color: '#e8e8e8', fontWeight: 700, fontSize: 16, minWidth: 24, textAlign: 'center' }}>{studentCount}</span>
                                    <button type="button" onClick={() => setStudentCount(v => v + 1)} style={counterBtn}>+</button>
                                </div>
                            </Form.Group>

                            {allStudents.length > 0 && (
                                <Form.Group className="mb-4">
                                    <Form.Label style={lbl}>Прив'язати учнів</Form.Label>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                                        {allStudents.map(s => (
                                            <button key={s.id} type="button" onClick={() => toggleStudent(s.id)} style={{
                                                padding: '5px 12px', borderRadius: 20, fontSize: 12, cursor: 'pointer',
                                                background: students.includes(s.id) ? '#9b59b622' : '#0f0f0f',
                                                border: students.includes(s.id) ? '1px solid #9b59b6' : '1px solid #2e2e2e',
                                                color: students.includes(s.id) ? '#9b59b6' : '#888',
                                                transition: 'all 0.15s',
                                            }}>
                                                {s.name}
                                            </button>
                                        ))}
                                    </div>
                                </Form.Group>
                            )}
                        </>
                    )}

                    {/* Series ID — dropdown of existing + manual */}
                    <Form.Group className="mb-4">
                        <Form.Label style={lbl}>
                            ID серії
                            <span style={{ color: '#3a3a3a', marginLeft: 6, fontWeight: 400, textTransform: 'none', fontSize: 10 }}>— необов'язково</span>
                        </Form.Label>
                        <select
                            value={seriesMode === 'manual' ? '__new__' : seriesId}
                            onChange={e => {
                                if (e.target.value === '__new__') {
                                    setSeriesMode('manual');
                                    setSeriesId('');
                                } else {
                                    setSeriesMode('select');
                                    setSeriesId(e.target.value);
                                }
                            }}
                            style={{ ...inp, width: '100%', padding: '9px 12px' }}
                        >
                            <option value="">— без серії —</option>
                            {seriesOptions.map(s => (
                                <option key={s.series_id} value={String(s.series_id)}>
                                    #{s.series_id} — {s.title}
                                </option>
                            ))}
                            <option value="__new__">Нова серія (ввести вручну)...</option>
                        </select>
                        {seriesMode === 'manual' && (
                            <Form.Control
                                type="number" min="1" value={seriesId}
                                onChange={e => setSeriesId(e.target.value)}
                                placeholder="ID серії, напр. 42"
                                style={{ ...inp, width: 180, marginTop: 6 }}
                            />
                        )}
                        <div style={{ color: '#444', fontSize: 11, marginTop: 3 }}>
                            Однаковий ID = одна серія занять (для учнів з кількома уроками на тиждень)
                        </div>
                    </Form.Group>

                    {/* Footer */}
                    <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', paddingTop: 8, borderTop: '1px solid #1e1e1e' }}>
                        <button type="button" onClick={onHide} style={{ ...footerBtn, color: '#555', background: '#0f0f0f', border: '1px solid #2e2e2e' }}>
                            Скасувати
                        </button>
                        <button type="submit" disabled={loading} style={{ ...footerBtn, background: selected?.dot ?? '#5865f2', color: '#fff', border: 'none', opacity: loading ? 0.7 : 1 }}>
                            {loading ? 'Створення...' : `Створити${recur === 'weekly' ? ' (×26)' : ''}`}
                        </button>
                    </div>
                </Form>
            </div>
        </Modal>
    );
}

const lbl        = { color: '#666', fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 6, display: 'block' };
const inp        = { background: '#0f0f0f', border: '1px solid #2e2e2e', color: '#e8e8e8', borderRadius: 8 };
const counterBtn = { background: '#0f0f0f', border: '1px solid #2e2e2e', color: '#e8e8e8', borderRadius: 6, width: 30, height: 30, cursor: 'pointer', fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' };
const footerBtn  = { padding: '9px 20px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600, transition: 'opacity 0.15s' };
